// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"143509b5","114":"f6cb1029","521":"592173ec","873":"87c3402b"}[chunkId] + ".chunk.js";
};